import { ReactComponent as FlagIcon } from "./svg/gt-flag.svg";
import "../flag-icon.scss";

export const GTFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
